<div 
  class="view-column-toggle"
  @show
  gaEvent
  gaCategory="View Information Panel"
  gaAction="Clicked Toggle Column"
  [gaLabel]="isIn ? 'Show' : 'Hide'"
  role="button"
  aria-label="Toggle Column"
  tabindex="0"
  matTooltip="Toggle Column"
  matTooltipPosition="right"
  (click)="handleToggle()"
  (keyup.enter)="handleToggle()"
  *ngIf="columnToggleVisible">
  <app-icon [icon]="isIn ? 'caret-right' : 'caret-left'"></app-icon>
</div>